<fuse-widget *ngIf="showInWidget" class="widget p-0 h-100-p" fxLayout="column" fxLayoutAlign="space-between center" fxFlex="100">
    <div class="fuse-widget-front mat-white-bg mat-elevation-z2 h-100-p" fxLayout="row" fxLayoutAlign="start center">
        <div class="htmlcontent" [innerHTML]="value | safeHtml"></div>
    </div>
</fuse-widget>

<div *ngIf="!showInWidget" fxLayout="row" fxLayoutAlign="start center" class="pt-12">
    <div [innerHTML]="value | safeHtml"></div>
</div>